export default "__VITE_ASSET__CGGAcZ72__"